module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_janne-jussila_A4.35aa1e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_janne-jussila_A4.pdf
// module id = MvgF
// module chunks = 22